<wms-dialog id="commitHistoryModal" customClasses="large wm-vcs-log-dialog">
    <wms-dialog-header (onClose)="vcsService.closeDialogWithId('commitHistoryModal')"
        title="{{locale['LABEL_VCS_MENU_VIEW_HISTORY']}}" helpTitle="{{locale['LABEL_VCS_MENU_VIEW_HISTORY']}}"
        helpLink="https://docs.wavemaker.com/learn/app-development/dev-integration/developer-collaboration/#view-changes"
        customClass="pullChanges-header"></wms-dialog-header>
    <wms-dialog-body>
        <div class="pending-prs" *ngIf="vcsService.gitStatus?.devBranchTrackingStatus">
          <h4>
            <span>{{locale['LABEL_PENDING_MERGE_REQUEST_CHANGES_' + projectService.teamProjectObject.vcsAccountDTO.vcsAccountType] || locale.LABEL_PENDING_MERGE_REQUEST_CHANGES_DEFAULT}}</span>
            <span>({{vcsService.gitStatus.devBranchTrackingStatus?.developmentBranch}})</span>
          </h4>
          <ng-container [ngTemplateOutlet]="headerTable"></ng-container>
          <div class="wm-log-container pending-pr-logs-container">
            <ng-container [ngTemplateOutlet]="bodyTable" [ngTemplateOutletContext]="{data: [vcsService.gitStatus.devBranchTrackingStatus.developerBranchCommitInfo], showCommitStatus: true}"></ng-container>
          </div>
        </div>
        <div class="merged-prs">
          <h4>
            <span>{{locale.LABEL_MERGED_CHANGES}}</span>
            <span *ngIf="vcsService.gitStatus?.repoRemoteTrackingStatus">({{vcsService.gitStatus.repoRemoteTrackingStatus.remoteTrackingBranchName}})</span>
            <span *ngIf="vcsService.behindCommitsMessage" class="behind-msg">{{vcsService.behindCommitsMessage}}</span>
          </h4>
          <ng-container [ngTemplateOutlet]="headerTable"></ng-container>
          <div class="wm-log-container">
            <ng-container [ngTemplateOutlet]="bodyTable" [ngTemplateOutletContext]="{data: vcsService.commitsList}"></ng-container>
          </div>
        </div>
    </wms-dialog-body>
    <wms-dialog-footer>
        <button class="btn button-secondary app-button" [disabled]="vcsService.isDisablePrevious"
            (click)="setOffset('prev')">{{locale['LABEL_NEWER']}}</button>
        <button class="btn btn-secondary" [disabled]="vcsService.isDisableNext"
            (click)="setOffset('next')">{{locale['LABEL_OLDER']}}</button>
    </wms-dialog-footer>
</wms-dialog>

<wms-vcs-view-commit-changes-dialog [selectedCommit]="selectedCommit"></wms-vcs-view-commit-changes-dialog>

<ng-template #headerTable>
  <table class="wm-table">
    <thead>
    <tr>
      <th class="commit-time">{{locale['LABEL_COMMIT_DATE']}}</th>
      <th class="commit-author">{{locale['LABEL_COMMIT_AUTHOR']}}</th>
      <th class="commit-msg">{{locale['LABEL_COMMIT_MESSAGE']}}</th>
    </tr>
    </thead>
  </table>
</ng-template>

<ng-template #bodyTable let-data="data" let-showCommitStatus="showCommitStatus">
  <table class="wm-table">
    <tbody>
      <tr *ngFor="let commit of data">
        <td class="commit-time">{{ commit.commitTime * 1000 | date: 'MMM dd, y, H:mm' }}</td>
        <td class="commit-author" [title]="commit.author.name">
          <p>{{ commit.author.name }}</p>
        </td>
        <td class="commit-msg">
          <div class="msg-container col-md-10">
            <p class="msg" [title]="commit.commitMessage.split('\n')[0]">
              <span>{{ commit.commitMessage.split('\n')[0]}}</span>
              <a (click)="toggleButton(commit)">[...]</a>
            </p>
            <ng-container *ngIf="commit.state === 'more'">
              <p [innerHTML]="commit.commitMessage.split('\n').slice(1).join('<br>')"></p>
              <p class="commit-id">{{locale['LABEL_COMMIT_ID']}}: {{commit.commitId }}</p>
            </ng-container>
          </div>
          <div class="col-md-2">
            <a (click)="showFilesListByCommit(commit)">
              {{locale['LABEL_VCS_MENU_VIEW_PROJECT_CHANGES']}}</a>
            <i class="wms wms-info-outline" *ngIf="showCommitStatus"
               [popover]="commitStatusPopover" triggers="mouseenter" [outsideClick]="true"
               containerClass="commit-status-popover" placement="left top" container="body"
               (mouseover)="getCommitStatus()"></i>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>

<ng-template #commitStatusPopover>
  <p [innerHtml]="commitStatus"></p>
  <a target="_blank" class="btn button-primary app-button create-pr-btn"
     [href]="projectService.teamProjectObject.createMrLink">{{locale.LABEL_CREATE }} {{(locale['LABEL_MERGE_REQUEST_' + this.projectService.teamProjectObject.vcsAccountDTO.vcsAccountType] || this.locale.LABEL_MERGE_REQUEST_DEFAULT) | titlecase}}</a>
</ng-template>
